<template lang="html">

  <article class="col-33 art-dest" data="fadeInUp">
    <router-link class="link-dest" :to="'/' + $t('enlaces.blog_noticia') + '/' + slug"></router-link>
    <div class="img-destacado" :style="`background: url('${server + data.img.enlace}') center/cover no-repeat`"></div>
    <div class="text-dest">
      <span class="date">{{ data.fecha | dateToHuman }}</span>
      <div class="container-text">
        <h3 v-html="data.titulo"></h3>
        <p v-html="data.entradilla"></p>
        <div class="flex row-reserve justify-between">
          <ul class="flex row">
            <li><i class="fa fa-eye" aria-hidden="true"></i><span>{{ data.hints }}</span></li>
            <li><i class="fa fa-comment-o" aria-hidden="true"></i><span>{{ data.comentarios }}</span></li>
            <like :slug="data.slugs[lang]" :likes="data.likes"></like>
          </ul>
          <a class="mas-dark"></a>
        </div>
      </div>
    </div>
  </article>

</template>

<script lang="js">

import { mapGetters, mapActions } from 'vuex';
import like from '@/components/parts/like'

export default {
  name: 'noticia-el',
  props: ['data'],
  mounted() {

    $(".destacados .art-dest").hover(function () {
      $(this).find('p').slideDown();
    }, function () {
      $(this).find('p').slideUp();
    });
  },
  components: {
    like
  },
  methods: {
    encodeURIOwn: function (value) {
      return value;;
    }
  },
  computed: {
    ...mapGetters({
      lang: 'getLanguage',
      server: 'getServer',
      itsLiked: 'getlike',
    }),
    slug: function () {
      return this.data.slugs[this.lang] ? this.data.slugs[this.lang] : this.data.slugs["en"];
    }
  },
  filters: {
    dateToHuman: function (value) { //Pasa la fecha de epoch a string
      let date = new Date(value);
      let dateString = `${date.getDate()}-${date.getMonth() + 1}-${date.getFullYear()}`;
      return dateString;
    }
  }
}
</script>

<style scoped>
.art-dest {
  opacity: 1;
}
</style>



// WEBPACK FOOTER //
// src/components/parts/noticia-el.vue